import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
  
}
const getters = {
  
}
const mutations = {
  
}
export default new Vuex.Store({
  getters,
  state,
  mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js